/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Banner from "../components/Common/Banner";
import AboutBanner from "../assests/bg-about.png";
import { CCol, CContainer, CRow } from "@coreui/react";
import SectionTitle from "../components/Common/SectionTitle";
// Forms
import ContactForm from "../components/Forms/ContactForm";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationArrow,
  // faLockOpen,
} from "@fortawesome/free-solid-svg-icons";

export default function Contact() {
  return (
    <>
      <Banner
        banner={AboutBanner}
        subtext={"Registered NDIS Provider"}
        text={"Contact us"}
      />
      {/* Contact Form Section */}

      <section className="contact-us-form-section-wrapper">
        <CContainer>
          <div className="contact-us-form-card">
            <CRow className="gx-0">
              <CCol lg={8}>
                <div className="main-form-wrapper">
                  <div className="mb-5">
                    <SectionTitle
                      align={"left"}
                      subTitle={"call to action"}
                      subtitle={true}
                      style2={true}
                      Title={"Send Us A Message"}
                    />
                  </div>
                  <ContactForm />
                </div>
              </CCol>
              <CCol lg={4} className="contact-form-bg"></CCol>
            </CRow>
          </div>
        </CContainer>
      </section>

      {/* Get In Touch  */}
      <section className="get-in-touch-section-wrapper">
        <CContainer>
          <CRow>
            <CCol lg={12}>
              <div className="mb-5">
                <SectionTitle
                  align={"center"}
                  subTitle={"contact"}
                  subtitle={true}
                  style2={true}
                  Title={"get in touch"}
                />
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg={8} className="mb-lg-0 mb-4">
              <div className="get-in-touch-card">
                <CRow className="gx-0">
                  <CCol lg={6}>
                    <div className="iframe">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.8970895894167!2d151.00561467643794!3d-33.81496871627394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12a318e1f4e887%3A0x562b4f255a665e94!2sUnit%2023%2F91%20George%20St%2C%20Parramatta%20NSW%202150%2C%20Australia!5e0!3m2!1sen!2s!4v1744535354165!5m2!1sen!2s"
                        loading="lazy"
                      ></iframe>
                    </div>
                  </CCol>
                  <CCol lg={6}>
                    <div className="info-widget-card px-lg-4 px-3 py-5">
                      <h4>head quarter</h4>
                      <div className="single-info-box contact-info mb-3">
                        <div className="single-info-icon">
                          <span>
                            <FontAwesomeIcon icon={faPhone} />
                          </span>
                        </div>
                        <div className="single-info-desc">
                          <Link
                            to={"tel:1300 853 204"}
                            className="d-block mb-2"
                          >
                            1300 853 204
                          </Link>
                          <Link to={"tel:0489 073 262"} className="d-block">
                            0489 073 262
                          </Link>
                        </div>
                      </div>
                      <div className="single-info-box contact-info mb-3">
                        <div className="single-info-icon">
                          <span>
                            <FontAwesomeIcon icon={faEnvelope} />
                          </span>
                        </div>
                        <div className="single-info-desc">
                          <Link
                            to={"mailto:info@wattlehealthcare.com.au"}
                            className="d-block"
                          >
                            info@wattlehealthcare.com.au
                          </Link>
                        </div>
                      </div>
                      <div className="single-info-box contact-info ">
                        <div className="single-info-icon">
                          <span>
                            <FontAwesomeIcon icon={faLocationArrow} />
                          </span>
                        </div>
                        <div className="single-info-desc">
                          <Link
                            to={"mailto:info@wattlehealthcare.com.au"}
                            className="d-block"
                          >
                            Level 2, Suite 3, 91 George Street, Parramatta 2150 NSW
                          </Link>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </div>
            </CCol>
            <CCol lg={4}>
              <div className="hours-card-wrapper px-lg-4 px-3 py-5">
                <div className="hours-card-box">
                  <h4>opening hours</h4>
                  <p>24 x 7 Open</p>
                </div>
                <div className="hours-card-box mt-5">
                  <h4 className="mb-4">contact hours</h4>
                  <CRow className="gx-0 mb-2">
                    <CCol xs={3}>
                      <div className="hours-label-wrapper">
                        <label>Mon-Fri</label>
                      </div>
                    </CCol>
                    <CCol xs={9}>
                      <div className="hours-label-wrapper text-end">
                        <label>10:00 am - 05:00 pm</label>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow className="gx-0">
                    <CCol xs={3}>
                      <div className="hours-label-wrapper">
                        <label>Sat-Sun</label>
                      </div>
                    </CCol>
                    <CCol xs={9}>
                    <div className="hours-label-wrapper text-end">
                        <label>10:00 am - 05:00 pm</label>
                      </div>
                    </CCol>
                  </CRow>
                </div>
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </section>
    </>
  );
}
